import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { CartItemType } from '@base/cart/interface';
import Image from '@base/lib/ThemeImage';
// import ProductCouponTag from '@base/snippets/ProductCouponTag';
import ListProductSoldOut from '@base/snippets/ListProduct/ListProductSoldOut';
import OrderProductTag from '@base/snippets/OrderProductTag';
import { ICartGroup } from 'mod/cart/interface';
import { useTrans } from 'base/utils/i18n';
import { ProductTag } from '@base/snippets/ProductTag'
import { getTagConfig } from 'mod/product/utils'
import { getCartItemTagConfig } from '@base/cart/utils'

type CartItemImageProps = {
    className?: string;
    item: CartItemType;
    width: number;
    batchActive?: boolean;
    group: ICartGroup;
};

const CartItemImage: React.FC<CartItemImageProps> = props => {
    const { className, item, width, batchActive = false, group } = props;
    const href = batchActive ? void 0 : item.productUrl;
    const { t } = useTrans();

    // 找到设置的tag配置
    const itemTagConfig = item.productTags ? getCartItemTagConfig(item.productTags) : void 0

    return (
        <div className={cn(styles['img-wrap'], className)}>
            <Image
                className="picture"
                href={href}
                src={item.productVariantPic}
                width={width}
            />

            {itemTagConfig ? (
                <div style={{ position: 'absolute', top: 0, left: 0, }}>
                    <ProductTag tagConfig={itemTagConfig}/>
                </div>
            ) : (
                <>
                    {!group.forceBatchOperate && <OrderProductTag product={item}/>}
                </>
            )}

            {/* 商品coupon优惠 */}
            {/*<ProductCouponTag className="tag" isShowPrice={false} discountPriceNumDisplay={item?.discountPriceNumDisplay}/>*/}

            {item.stockNum === 0 && (
                <ListProductSoldOut
                    link={href}
                    text={t('web_product_sold_out')}
                    className="sold-out"
                    canJump={!batchActive}
                />
            )}
        </div>
    )
};

export default CartItemImage;